import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

/**
 * BOS+ Phase 7 — Global Payroll shell. Sidebar nav + <Outlet/>, reusing the
 * shared `hr-shell` layout (mirrors TimeShell). Additive payroll layer that
 * coexists with the core `/payroll` module.
 */

const NAV = [
  { to: '/payroll-global/runs', label: 'Run Workbench', testid: 'payroll-global-nav-runs' },
  { to: '/payroll-global/pay-groups', label: 'Pay Groups & Calendars', testid: 'payroll-global-nav-paygroups' },
  { to: '/payroll-global/components', label: 'Component Library', testid: 'payroll-global-nav-components' },
  { to: '/payroll-global/jurisdictions', label: 'Jurisdictions & Rules', testid: 'payroll-global-nav-jurisdictions' },
];

export default function PayrollGlobalShell() {
  return (
    <div className="hr-shell" data-testid="payroll-global-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Global Payroll</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
